import { setWinStatusAction } from 'core/widgets/WinStatus/actions';
import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { OnPlayerResultData } from '../types';

export function* onPlayerResultSaga({ type: notificationType, data: result }: OnPlayerResultData) {
  if (notificationType === Notifications.PLAYER_RESULT) {
    const { betAmount, winAmount, drawResult } = result;

    yield put(
      setWinStatusAction({
        winner: drawResult,
        winningAmount: winAmount || 0,
        betAmount: betAmount || 0,
      }),
    );
  }
}
